const ConsentContent = () => {
	return null;
};

export default ConsentContent;
